export const parseOddByPrecision = (totalOdd, precision) => {
  const re = new RegExp(`^-?\\d+(?:.\\d{0,${precision || 2}})?`);
  return totalOdd?.toString().match(re)[0];
};
